import React, { SVGProps } from "react";

export const CartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" width={20} height={20} {...props}>
    <circle cx={9} cy={21} r={1} stroke="currentColor" strokeWidth="2" />
    <circle cx={20} cy={21} r={1} stroke="currentColor" strokeWidth="2" />
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"
    />
  </svg>
);

export default CartIcon;
